import { render } from "./upload-image.vue?vue&type=template&id=0f0dd4bc&scoped=true"
import script from "./upload-image.vue?vue&type=script&lang=js"
export * from "./upload-image.vue?vue&type=script&lang=js"

import "./upload-image.vue?vue&type=style&index=0&id=0f0dd4bc&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0dd4bc"]])

export default __exports__